module.exports = __webpack_public_path__ + "img/signature.4cb33693.png";